<script setup lang="ts">

import DashboardLayout from '@/onenetwork/layouts/DashboardLayout.vue'
import VersionDetail from '@/modules/setting/views/VersionDetail.vue'
import MembershipDetail from '@/modules/setting/views/MembershipDetail.vue'
</script>

<template>
  <dashboard-layout currentRoute="system/memberships" page-title="Tạo gói hội viên">
    <MembershipDetail id="0" action="create"/>
  </dashboard-layout>
</template>

<style scoped>

</style>
